export const STATUS_PENDING = 'PENDING';
export const STATUS_OK = 'OK';
export const STATUS_FAILED = 'FAILED';
export const STATUSES = [STATUS_PENDING, STATUS_OK, STATUS_FAILED];
